import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
export const configured = !!(url && key);
/** an invite or password-reset link opened the app ("invite" / "recovery"): read before the client clears the address */
export const authLinkType = new URLSearchParams(location.hash.slice(1)).get("type");
export const sb = createClient(url || "http://localhost", key || "missing", { auth: { persistSession: true } });
export const functionsUrl = (name: string) => `${url}/functions/v1/${name}`;

/** call an edge function as the signed-in user; returns the JSON (errors included, with ok = false) */
export async function callFn(name: string, body: unknown): Promise<any> {
  const { data: s } = await sb.auth.getSession();
  const r = await fetch(functionsUrl(name), { method: "POST", body: JSON.stringify(body),
    headers: { "content-type": "application/json", apikey: key!, Authorization: `Bearer ${s.session?.access_token ?? ""}` } });
  const j = await r.json().catch(() => ({ error: `HTTP ${r.status}` }));
  return { ok: r.ok, ...j };
}

/** an RPC that throws the database's message */
export async function rpc<T = unknown>(fn: string, args: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await sb.rpc(fn, args);
  if (error) throw new Error(error.message);
  return data as T;
}
